const STRINGS = {
  en: {
    learnMore: 'Learn More',
    yourPathway: 'Your Pathway',
    emailIt: 'Email it',
    clear: 'Clear',
    emailYourPathway: 'Email Your Pathway',
    emailPlaceholder: 'Please enter email address',
    invalidEmail: 'Please enter a valid email address',
    send: 'Send',
    cancel: 'Cancel',
    loadingData: 'Loading Pathway Data...',
    error: 'Error',
    errorLoading: 'Failed to load data. Please try again later.',
    noDataTitle: 'No Data',
    noDataMessage: 'Could not load pathway data. Please try again later.',
    linkLabelSelectDegreeLevel: 'Select degree level:',
    linkLabelSelectJob: 'Select a Job',
    linkLabelSelectAnyOpportunities: 'Select any opportunities:',
    toastEmailSent: 'Email sent',
    toastPlanCleared: 'Plan cleared',
    toastOpportunityAdded: 'Opportunity added',
    toastOpportunityRemoved: 'Opportunity removed',
  },
  es: {
    learnMore: 'Aprender más',
    yourPathway: 'Tu Trayectoria',
    emailIt: 'Enviar por correo',
    clear: 'Limpiar',
    emailYourPathway: 'Enviar Tu Trayectoria',
    emailPlaceholder: 'Por favor ingrese el correo electrónico',
    invalidEmail: 'Por favor ingrese un correo electrónico válido',
    send: 'Enviar',
    cancel: 'Cancelar',
    loadingData: 'Cargando datos de la trayectoria...',
    error: 'Error',
    errorLoading: 'No se pudieron cargar los datos. Inténtelo de nuevo más tarde.',
    noDataTitle: 'Sin datos',
    noDataMessage: 'No se pudo cargar la información. Inténtelo más tarde.',
    linkLabelSelectDegreeLevel: 'Selecciona el nivel de grado:',
    linkLabelSelectJob: 'Selecciona un trabajo',
    linkLabelSelectAnyOpportunities: 'Selecciona cualquier oportunidad:',
    toastEmailSent: 'Correo enviado',
    toastPlanCleared: 'Plan borrado',
    toastOpportunityAdded: 'Oportunidad agregada',
    toastOpportunityRemoved: 'Oportunidad eliminada',
  }
};

export function getStrings(lang) {
  const l = (lang || 'en').toLowerCase().startsWith('es') ? 'es' : 'en';
  return STRINGS[l];
}
